import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { message } from 'antd'
import type { SuburbConfig } from 'config/constants/types'
import type { CouncilsListingsState, CouncilsListing } from '../types'
import { getSuburbListings, getSuburbListingsSuburb } from './helpers'

const noCouncilsListingsConfig = {
  listings: [],
  isInitalized: false,
  isLoading: true,
  hasError: false,
  suburb: null,
  suburbIsLoading: true,
  suburbIsInitalized: false,
}

interface SetListingsPayload {
  listings: CouncilsListing[]
}

interface SetSuburbPayload {
  suburb: SuburbConfig
}

const initialState: CouncilsListingsState = { ...noCouncilsListingsConfig }

export const councilsListingsSlice = createSlice({
  name: 'CouncilsListings',
  initialState,
  reducers: {
    fetchListings: (state) => {
      state.isLoading = true
      state.hasError = false
    },
    setListings: (state, action: PayloadAction<SetListingsPayload>) => {
      state.listings = action.payload.listings
      state.isLoading = false
      state.isInitalized = true
      state.hasError = false
    },
    fetchListingsFailed: (state) => {
      state.listings = []
      state.isInitalized = false
      state.isLoading = false
      state.hasError = true
    },
    fetchSuburb: (state) => {
      state.suburbIsLoading = true
    },
    setSuburb: (state, action: PayloadAction<SetSuburbPayload>) => {
      state.suburb = action.payload.suburb
      state.suburbIsLoading = false
      state.suburbIsInitalized = true
    },
  },
})

export const fetchSuburbListings = (suburbId: string, ownerId: string) => async (dispatch) => {
  try {
    dispatch(fetchListings())
    const listings = await getSuburbListings(suburbId, ownerId)
    dispatch(
      setListings({
        listings,
      }),
    )
  } catch (error) {
    message.error('Error gettings stats')
    dispatch(fetchListingsFailed())
  }
}

export const fetchSuburbListingsSuburb = (suburbId: string) => async (dispatch) => {
  try {
    dispatch(fetchSuburb())
    const suburb = await getSuburbListingsSuburb(suburbId)
    dispatch(
      setSuburb({
        suburb,
      }),
    )
  } catch (error) {
    message.error('Error getting suburb')
  }
}

// Actions
export const { fetchListings, setListings, fetchListingsFailed, fetchSuburb, setSuburb } = councilsListingsSlice.actions

export default councilsListingsSlice.reducer
